import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UserLoginPage.css";
import logo from "../assets/logo.png";



function UserLoginPage() {
  const [step, setStep] = useState("email"); // "email" | "password" | "reset"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const navigate = useNavigate();

  // Step 1: Check pin_reset
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/user/check-pin-reset", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();

      if (!response.ok) {
        alert(data.message || "Email not found");
        return;
      }

      if (data.pin_reset === 1) {
        // Normal login flow
        setStep("password");
      } else if (data.pin_reset === 0) {
        // Require reset first
        setShowResetModal(true);
        setStep("reset");
      }
    } catch (error) {
      console.error("Error checking pin_reset:", error);
      alert("Server error. Try again.");
    }
  };

  // Step 2a: Reset password if needed
  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    try {
      const response = await fetch("/api/user/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, newPassword }),
      });
      const data = await response.json();

      if (response.ok) {
        alert("Password reset successful! Please log in.");
        setShowResetModal(false);
        setStep("password");
      } else {
        alert(data.message || "Password reset failed");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      alert("Server error. Try again.");
    }
  };

  // Step 2b: Login normally
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/user/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user_id", data.user_id);
        localStorage.setItem("permissions", JSON.stringify(data.permissions || []));
        alert("Login successful!");
        window.location.href = data.secure_url;
      } else {
        alert(data.message || "Login failed");
      }
    } catch (error) {
      console.error("Error during login:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="home-container">
      <div className="login-box">
        <div className="logo-container" onClick={() => navigate("/")}>
          <img src={logo} alt="Company Logo" className="clickable-logo" />
        </div>

        {step === "email" && (
          <>
            <h1>User Login</h1>
            <form onSubmit={handleEmailSubmit}>
              <div>
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit">Next</button>
            </form>
          </>
        )}

        {step === "password" && (
          <>
            <h1>Enter Password</h1>
            <form onSubmit={handleLoginSubmit}>
              <div>
                <label htmlFor="password">Password:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit">Login</button>
            </form>
          </>
        )}
      </div>

      {/* 🔒 Reset Password Modal */}
      {showResetModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Reset Password</h2>
            <form onSubmit={handleResetPassword}>
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <div className="modal-actions">
                <button type="submit">Save</button>
                <button type="button" onClick={() => setShowResetModal(false)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserLoginPage;
